import AllEntityInfo from "@common/components/overviewStepSection/AllEntityInfo";
import { EntityType } from "@common/Common.types.ts";
import { useAllLegalEntityInfo } from "./AllLegalEntityInfo.hooks";
import { topPaperMinHeight } from "../LegalEntity";
import useLegalEntityDisplayFields, { getLegalEntityFieldDisplayName } from "../legalEntities/legalEntityDisplayFields/LegalEntityDisplayFields.hooks";
import { LegalEntityScope } from "../legalEntities/LegalEntities.types";
import { useUrlProvider } from "../../useUrlProvider";

export interface AllLegalEntityInfoProps {
    legalEntityId: string;
    legalEntityScope: LegalEntityScope;
}

function AllLegalEntityInfo(props: AllLegalEntityInfoProps) {
    const { isLoading, data } = useAllLegalEntityInfo(props);
    const { getTableFieldsDictionary, isLoading: isFieldsLoading } = useLegalEntityDisplayFields(props.legalEntityScope);
    const { getLegalEntityEditUrl } = useUrlProvider();

    return (
        <AllEntityInfo
            entityId={props.legalEntityId}
            entityType={EntityType.LegalEntity}
            steps={data?.steps}
            isLoading={isLoading || isFieldsLoading}
            getFieldDisplayName={getLegalEntityFieldDisplayName}
            dictionary={getTableFieldsDictionary()}
            getNavigateUrl={(entityId, stepOrder) => getLegalEntityEditUrl(props.legalEntityScope, entityId, `step=${stepOrder}`)}
            minHeight={topPaperMinHeight}
        />
    );
}

export default AllLegalEntityInfo;
